/* eslint-disable jsx-a11y/alt-text */
import { useEffect } from "react";
import "../styles/componentStyles/InstructionsComponent.scss";
import { ACTION_TRIGGERS } from "../webar-core/framework/ActionTriggers";
import { useStore } from "../webar-core/framework/store/Store";
import cn from "../languages/cn";
/**
 * This Component shows instructions for the user
 * @param props
 * @returns
 */
export const InstructionsComponent = (props: any) => {
  const triggerAction = useStore((store) => store.triggerAction);

  useEffect(() => {
    if (props.enableInstructions) {
      setTimeout(() => {
        props.instructionsEnded(true);
        triggerAction(
          ACTION_TRIGGERS.ENABLE_POST_PERMISSION_CONTENT,
          "App",
          undefined,
          false
        );
      }, 5000);
    }
  });

  return (
    <div
      id="instructions"
      className={`${props.enableInstructions ? "animateIn" : ""}`}
    >
      <div id="instruction1">
        {props.translate ? cn.instruction1.text : "Turn volume up"}
      </div>
      <img
        id="volumeUpImage"
        src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/soundIcon.png"
      />
      <div id="instruction2">
        {props.translate ? cn.instruction2.text : "Let's begin"}
      </div>
    </div>
  );
};
